/*
 * @Author: Smion Li
 * @Date: 2020-11-18 15:26:04
 * @LastEditTime: 2022-11-15 09:53:16
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/utils/mixin.js
 */
import Vue from 'vue'
import Component from 'vue-class-component'
import dayjs from 'dayjs'
import router from '@/router'
import { _getNowOperatingHours } from 'utils'
import _lodash from 'lodash'

import {
  mapState,
} from 'vuex'
import { getVenueGroup, getVenue } from '../api/product'

@Component({
  computed: {
    ...mapState({
      isOnline: state => state.app.isOnline,
      currentVenueId: state => state.venueId,
      currentCartList: state => state.productList,
    }),
  },
  watch: {
    currentVenueId: {
      immediate: true,
      handler(val, old) {
        if (!this.$route.name.includes('venue-sub-group')) {
          this.__syncCurrentVenueCartWIthGroupCart(val)
        }
      }
    },
    currentCartList: {
      immediate: true,
      deep: true,
      handler(val, old) {
        if (!this.$route.name.includes('venue-sub-group')) {
          if (JSON.stringify(val) !== JSON.stringify(old)) {
            this.__syncVenueCartInGroupCartList(val)
          }
        }
      }
    },
  }
})

export default class MyMixin extends Vue {
  waitingTimeSetting = {}
  mixinValue = 'Hello'
  isOriginalVenueOpenTime = true
  isVenueOpenTime = true
  enableMarketingConsent = false
  enableTipping = true
  enableTab = false
  logoImgSrc = ''
  tipPercentList = [0.05, 0.1, 0.15]
  marketingConsentMessage = ''
  posStatus = null

  async __checkVenueTodayIsOpenTime(fun) {
    this.$store.commit('showLoading')
    const isOpen = await this.__checkVenueOpenTime()
    if (isOpen) {
      fun()
    } else {
      this.__jumpToIndex()
      this.$store.commit('closeLoading')
    }
  }

  async __checkVenueSubgroupTodayIsOpenTime(fun) {
    this.$store.commit('showLoading')
    const isOpen = await this.__checkVenueSubgroupOpenTime()
    if (isOpen) {
      fun()
    } else {
      if (this.$store.state.venueHome.routerInfo.number) {
        this.$router.push(`/vgs/${this.venueSubGroupId}/t/${this.$store.state.venueHome.routerInfo.number}`)
      } else {
        this.$router.push(`/vgs/${this.venueSubGroupId}`)
      }
      this.$store.commit('closeLoading')
    }
  }

  __jumpToIndex() {
    if (this.$store.state.venueHome.routerInfo.number) {
      this.$router.push(`/v/${this.venueId}/home/t/${this.$store.state.venueHome.routerInfo.number}`)
    } else {
      this.$router.push(`/v/${this.venueId}/home/p`)
    }
  }

  /**
   * TODO: check subgroup open time
   * @returns {Promise<boolean>}
   * @private
   */
  async __checkVenueSubgroupOpenTime() {
    this.isVenueOpenTime = true
    return true
  }

  async __getVenueSubGroupOpenTime() {
    try {
      const venueSubGroupInfo = await getVenueGroup({
        id: router.currentRoute.params.venueSubGroupId,
        venueSubGroupId: router.currentRoute.params.venueSubGroupId,
        type: 'subGroup'
      })
      // const tipPercentList = venueSubGroupInfo.settings.options.tippingRates
      // if (tipPercentList) {
      //   if (!Object.keys(tipPercentList).length) return
      //
      //   this.tipPercentList = [
      //     tipPercentList.first,
      //     tipPercentList.second,
      //     tipPercentList.third
      //   ]
      // }
      // this.enableMarketingConsent = venueSubGroupInfo.settings.options.enableMarketingConsent ?? false
      // this.enableTipping = venueSubGroupInfo.settings.options.enableTipping ?? false
      // // The enableTab in the API has changed the data structure. If no new data is found, the old data value will be taken
      // // API 中 enableTab 更换过数据结构，若找不到新数据，就取旧数据的值
      // this.enableTab = venueSubGroupInfo.settings?.dineInSettings?.enableCustomerTab ?? false
      // // @todo default img is logo
      // this.logoImgSrc = venueSubGroupInfo.secLogo || venueSubGroupInfo.logo
      // this.waitingTimeSetting = {
      //   enableWaitingTime: venueSubGroupInfo.settings.waitingTimeSettings?.enableWaitingTime,
      //   awaitingTime: venueSubGroupInfo.averageWaitingTime,
      //   awaitingType: venueSubGroupInfo.averageWaitingTimeType
      // }
      // this.marketingConsentMessage = venueSubGroupInfo.settings.options.marketingConsentMessage
      // this.posStatus = venueSubGroupInfo.settings.posStatus
      // this.orderThrottlingSettings = venueSubGroupInfo.settings?.orderThrottlingSettings ?? {}
      // return venueSubGroupInfo.todayOperatingHours
      this.enableTipping = false
    } catch (error) {
      console.log(error)
      this.$store.commit('closeLoading')
    }
  }

  // Check whether the venue is open
  // 检查 venue 是否在开放时间
  async __checkVenueOpenTime() {
    let res = false
    const {
      week,
      time
    } = this.__getTime()
    const venueOperationTime = await this.__getVenueOpenTime()
    if (venueOperationTime && venueOperationTime.enable) {
      try {
        const result = _getNowOperatingHours(venueOperationTime, time)
        if (result) res = true
      } catch (error) {
        console.log(error)
      }
    }

    // Judge whether posStatus meets the requirements
    // 判断 posStatus 是否满足需求
    if (this.posStatus && this.posStatus.enable && this.posStatus.status !== 1) res = false
    // this.isVenueOpenTime = res
    // In order to be compatible with delivery, isOnline judgment is added
    // 为了兼容外卖，多加了 isOnline 判断 by@可乐
    this.isOriginalVenueOpenTime = res
    this.isVenueOpenTime = res || this.isOnline
    return res || this.isOnline
  }

  __getTime() {
    const week = dayjs(this.$store.state.app.currentVenueTime).format('dddd').toLowerCase()
    const time = dayjs(this.$store.state.app.currentVenueTime).format('HH:mm')
    return {
      week,
      time
    }
  }

  // Get the information of venue
  // 获取 venue 的信息
  async __getVenueOpenTime() {
    try {
      const venueInfo = await getVenue({
        id: router.currentRoute.params.venueId
      })
      const tipPercentList = venueInfo.settings.options.tippingRates
      if (tipPercentList) {
        if (!Object.keys(tipPercentList).length) return

        this.tipPercentList = [
          tipPercentList.first,
          tipPercentList.second,
          tipPercentList.third
        ]
      }
      this.enableMarketingConsent = venueInfo.settings.options.enableMarketingConsent
      this.enableTipping = venueInfo.settings.options.enableTipping
      // The enableTab in the API has changed the data structure. If no new data is found, the old data value will be taken
      // API 中 enableTab 更换过数据结构，若找不到新数据，就取旧数据的值
      this.enableTab = venueInfo.settings?.dineInSettings?.enableCustomerTab ?? false
      // @todo default img is logo
      this.logoImgSrc = venueInfo.secLogo || venueInfo.logo
      this.waitingTimeSetting = {
        enableWaitingTime: venueInfo.settings.waitingTimeSettings?.enableWaitingTime,
        awaitingTime: venueInfo.averageWaitingTime,
        awaitingType: venueInfo.averageWaitingTimeType
      }
      this.marketingConsentMessage = venueInfo.settings.options.marketingConsentMessage
      this.posStatus = venueInfo.settings.posStatus
      this.orderThrottlingSettings = venueInfo.settings?.orderThrottlingSettings ?? {}
      return venueInfo.todayOperatingHours
    } catch (error) {
      console.log(error)
      this.$store.commit('closeLoading')
    }
  }

  __syncCurrentVenueCartWIthGroupCart(venueId) {
    if (this.$store.state.venueHome.subGroupId) {
      if (!this.$store.state.venueHome.stateVenueId) {
        this.$store.commit('saveStateVenueId', this.currentVenueId)
        this.$store.commit('replaceCurrentCart', this.$store.state.venueHome.subGroupCartList[this.currentVenueId]?.cart ?? [])
      } else if (this.$store.state.venueHome.stateVenueId !== venueId) {
        this.$store.commit('saveStateVenueId', this.currentVenueId)
        this.$store.commit('replaceCurrentCart', this.$store.state.venueHome.subGroupCartList[this.currentVenueId]?.cart ?? [])
      } else {
        this.$store.commit('replaceCurrentCart', this.$store.state.venueHome.subGroupCartList[this.currentVenueId]?.cart ?? [])
      }
    }
  }

  __syncVenueCartInGroupCartList(list) {
    // console.log(list)
    if (this.$store.state.venueHome.subGroupId) {
      // console.log('update sub group')
      if (this.$store.state.venueHome.stateVenueId !== this.currentVenueId) {
        // console.log('update sub 1')
      } else {
        if (JSON.stringify(this.$store.state.venueHome.subGroupCartList[this.currentVenueId]?.cart) !== JSON.stringify(list)) {
          // console.log('update sub 5')
          // same venue update
          this.$store.commit('saveSubGroupVenueCartList', {
            list: list,
            cartInfo: {
              paymentSurcharge: this.$store.state.app.paymentSurcharge,
              paymentSurchargeSettings: this.$store.state.app.paymentSurchargeSettings,
              merchantFee: this.$store.state.app.merchantFee,
              // 这家店的附加费判定依据：结账前 / 多店购物车开着时按它重判费率（utils/surchargeSnapshot.js refreshSubGroupSurcharges）
              surchargeSource: this.$store.state.app.surchargeSource,
            },
            venueId: this.currentVenueId
          })
        }
      }
    }
  }
}
